import { render, staticRenderFns } from "./SectionBtn.vue?vue&type=template&id=7a5e2015&"
import script from "./SectionBtn.vue?vue&type=script&lang=js&"
export * from "./SectionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports